import styled from "styled-components";
import { Grid } from "semantic-ui-react";

// Compliance
export const ComplianceContainer = styled(Grid.Row)({
  display: "flex !important",
  marginTop: 0,
  padding: "0 !important",
  firstChild: {
    marginRight: "10px !important",
  },
});
